import { render, staticRenderFns } from "./EdenTabToggle.vue?vue&type=template&id=0f78c144&scoped=true"
import script from "./EdenTabToggle.vue?vue&type=script&lang=js"
export * from "./EdenTabToggle.vue?vue&type=script&lang=js"
import style0 from "./EdenTabToggle.vue?vue&type=style&index=0&id=0f78c144&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f78c144",
  null
  
)

export default component.exports